export default __webpack_public_path__ + "static/media/a.c37c345e.png";